<template>
  <NuxtLink :to="rutaInicio" class="mt-marca" :class="{ 'mt-marca--claro': claro }" aria-label="minotaria, inicio">
    <!-- width/height propios: sin ellos, mientras llega minotaria.scss, el SVG ocupa todo el ancho -->
    <svg class="mt-marca__icono" width="34" height="34" viewBox="0 0 32 32" aria-hidden="true">
      <rect x="1" y="1" width="30" height="30" rx="8" fill="currentColor" />
      <path d="M9 22V11.5l7 6 7-6V22" fill="none" stroke="#fff" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" />
      <circle cx="23.5" cy="8.5" r="2.6" fill="var(--mt-acento)" />
    </svg>
    <span class="mt-marca__texto">mi<strong>notaria</strong></span>
  </NuxtLink>
</template>

<script setup lang="ts">
import { computed } from 'vue'
defineProps<{ claro?: boolean }>()
const route = useRouter().currentRoute
const rutaInicio = computed(() => (route.value.params.lang ? `/${route.value.params.lang}` : '') + '/')
</script>
